import { render, staticRenderFns } from "./adminsIndex.vue?vue&type=template&id=27685e08&"
import script from "./adminsIndex.vue?vue&type=script&lang=js&"
export * from "./adminsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports